import { Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../utils/Utils";

// To deploy on localhost
// npm run start

// To deploy to firebase
// npm run build
// firebase deploy --only hosting

const NotFound = () => {
  const { t } = useTranslation();
  trackEvent("notfound-opened");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        {t("notFound.title")}
      </Typography>
      <Typography variant="body1" align="center" gutterBottom>
        {t("notFound.message")}
      </Typography>
      <Button component={Link} to="/" variant="contained" color="secondary">
        {t("notFound.button")}
      </Button>
    </Box>
  );
};

export default NotFound;
